import DateHelper from "../../../../helpers/date-helper";
import DictionaryAll from "../../../../models/dictionary-all";
import Result from "../../../../models/result";
import WidgetRequest from "../../../../models/widget-request";
import { IAction, IDictsAction, ISetBookVisitAction, ISetCurrentPresentedDateIndexAction, ISetRegionCodeAction, ISetServiceInOfficeAction, ISetStartPresentedIndexAction, ISetStopPresentedIndexAction, ISetRequestAction, ISetResultAction, ISetRegionDescriptionAction, ISetSpecialisationCodeAction, ISetSpecialisationDescriptionAction, ISetSelectedDateAction, ISetPresentedDateAction, ISetWidgetSize, ISetIsLoading, ISetSelectedTimeInterval, ISetClinics, ISetClinicCode, ISetVendor, ISetDoctors, ISetSpecialities, ISetAggregatedData, ISetAvailableDays, ISetClinicDescriptionAction, ISetAggregatedDataToDisplay, ISetSlotsNotAvailable, ISetIsTelemedicineAvailable, ISetIsOfficeAvailable } from "./common-actions";
import SlotInterval from "../../../../models/enums/slot-interval";
import DictionaryItem from "../../../../models/dictionary-item";
import ActionType from "../../../../models/enums/action-type";

export interface IWidgetState {
  today: Date,
  nextPossibleDays: number,
  maxAppointmentsToShow: number,
  presentedDates: Date[],
  selectedDate: Date,
  lastPossibleDate: Date,
  allDays: Date[],
  allDicts: DictionaryAll,
  request: WidgetRequest,
  result: Result,
  selectedRegionCode: string,
  selectedRegionDescription: string,
  selectedSpecialisationCode: string,
  selectedSpecialisationDescription: string,
  selectedClinicCode: string,
  startPresentedDateIndex: number,
  stopPresentedDateIndex: number,
  currentPresentedDateIndex: number,
  serviceInOffice: boolean,
  bookVisit: boolean,
  widgetSize: string,
  isLoading: boolean,
  slotInterval: SlotInterval,
  clinics: DictionaryItem[],
  vendor: string,
  doctors: DictionaryItem[],
  specialities: DictionaryItem[],
  aggregatedData: [],
  aggregatedDataToDisplay: [],
  availableDays: [],
  selectedClinicDescription: string,
  slotsNotAvailable: boolean,
  isTelemedicineAvailable: boolean
}

export const initialState: IWidgetState = {
  today: new Date(),
  nextPossibleDays: 10,
  maxAppointmentsToShow: 50,
  presentedDates: [],
  selectedDate: new Date(),
  lastPossibleDate: DateHelper.addDays(new Date(), 10),
  allDays: DateHelper.getDates(new Date(), DateHelper.addDays(new Date(), 10)),
  allDicts: new DictionaryAll(),
  request: new WidgetRequest(),
  result: new Result(),
  selectedRegionCode: "",
  selectedRegionDescription: "",
  selectedSpecialisationCode: "",
  selectedSpecialisationDescription: "",
  selectedClinicCode: "",
  startPresentedDateIndex: 0,
  stopPresentedDateIndex: 0,
  currentPresentedDateIndex: 0,
  serviceInOffice: true,
  bookVisit: true,
  widgetSize: "",
  isLoading: false,
  slotInterval: SlotInterval.none,
  clinics: [],
  vendor: "",
  doctors: [],
  specialities: [],
  aggregatedData: [],
  aggregatedDataToDisplay: [],
  availableDays: [],
  selectedClinicDescription: "",
  slotsNotAvailable: false,
  isTelemedicineAvailable: true
}

export const commonReducer = (state: IWidgetState, action: IAction) => {
  switch (action.type) {
    case ActionType.setDicts:
      return {
        ...state,
        allDicts: (action as IDictsAction).payload.allDicts
      };
    case ActionType.setRequest:
      return {
        ...state,
        request: (action as ISetRequestAction).payload.request
      };
    case ActionType.setResult: {
      return {
        ...state,
        result: (action as ISetResultAction).payload.result
      }
    };
    case ActionType.setRegionCode:
      return {
        ...state,
        selectedRegionCode: (action as ISetRegionCodeAction).payload.selectedRegionCode
      };
    case ActionType.setRegionDescription:
      return {
        ...state,
        selectedRegionDescription: (action as ISetRegionDescriptionAction).payload.selectedRegionDescription
      }
    case ActionType.setSpecialisationCode:
      return {
        ...state,
        selectedSpecialisationCode: (action as ISetSpecialisationCodeAction).payload.selectedSpecialisationCode
      };
    case ActionType.setSpecialisationDescription:
      return {
        ...state,
        selectedSpecialisationDescription: (action as ISetSpecialisationDescriptionAction).payload.selectedSpecialisationDescription
      };
    case ActionType.setSelectedDate:
      return {
        ...state,
        selectedDate: (action as ISetSelectedDateAction).payload.selectedDate
      };
    case ActionType.setPresentedDates:
      return {
        ...state,
        presentedDates: (action as ISetPresentedDateAction).payload.presentedDates
      };
    case ActionType.setStartPresentedDateIndex:
      return {
        ...state,
        startPresentedDateIndex: (action as ISetStartPresentedIndexAction).payload.startPresentedDateIndex
      };
    case ActionType.setStopPresentedDateIndex:
      return {
        ...state,
        stopPresentedDateIndex: (action as ISetStopPresentedIndexAction).payload.stopPresentedDateIndex
      };
    case ActionType.setCurrentPresentedDateIndex:
      return {
        ...state,
        currentPresentedDateIndex: (action as ISetCurrentPresentedDateIndexAction).payload.currentPresentedDateIndex
      };
    case ActionType.setServiceInOffice:
      return {
        ...state,
        serviceInOffice: (action as ISetServiceInOfficeAction).payload.serviceInOffice
      };
    case ActionType.setBookVisit:
      return {
        ...state,
        bookVisit: (action as ISetBookVisitAction).payload.bookVisit
      };
    case ActionType.setIsLoading:
      return {
        ...state,
        isLoading: (action as ISetIsLoading).payload.isLoading
      };
    case ActionType.setSelectedTimeInterval:
      return {
        ...state,
        slotInterval: (action as ISetSelectedTimeInterval).payload.slotInterval
      };
    case ActionType.setClinics:
      return {
        ...state,
        clinics: (action as ISetClinics).payload.clinics
      };
    case ActionType.setClinicCode:
      return {
        ...state,
        selectedClinicCode: (action as ISetClinicCode).payload.selectedClinicCode
      };
    case ActionType.setWidgetSize:
      return {
        ...state,
        widgetSize: (action as ISetWidgetSize).payload.widgetSize
      };
    case ActionType.setVendor:
      return {
        ...state,
        vendor: (action as ISetVendor).payload.vendor
      };
    case ActionType.setDoctors:
      return {
        ...state,
        doctors: (action as ISetDoctors).payload.doctors
      };
    case ActionType.setSpecialities:
        return {
          ...state,
          specialities: (action as ISetSpecialities).payload.specialities
        };
    case ActionType.setAggregatedData:
        return {
          ...state,
          aggregatedData: (action as ISetAggregatedData).payload.aggregatedData
        };
    case ActionType.setAvailableDays:
      return {
        ...state,
        availableDays: (action as ISetAvailableDays).payload.availableDays
      };
    case ActionType.setClinicDescription:
        return {
          ...state,
          selectedClinicDescription: (action as ISetClinicDescriptionAction).payload.selectedClinicDescription
      };
    case ActionType.setAggregatedDataToDisplay:
        return {
          ...state,
          aggregatedDataToDisplay: (action as ISetAggregatedDataToDisplay).payload.aggregatedData
        };
    case ActionType.setSlotsNotAvailable:
        return {
          ...state,
          slotsNotAvailable: (action as ISetSlotsNotAvailable).payload.slotsNotAvailable
        };
    case ActionType.setIsTelemedicineAvailable:
        return {
          ...state,
          isTelemedicineAvailable: (action as ISetIsTelemedicineAvailable).payload.isTelemedicineAvailable
        };
    case ActionType.setIsOfficeAvailable:
      return {
          ...state,
          isOfficeAvailable: (action as ISetIsOfficeAvailable).payload.isOfficeAvailable
        };
    default:
      return state;
  }
}